import { render } from "./RecipesPageList.vue?vue&type=template&id=13a05ef3"
import script from "./RecipesPageList.vue?vue&type=script&lang=js"
export * from "./RecipesPageList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__